import { useEffect, useState } from "react";
import { behaviorTimerClient } from "../../../util/src/behavior-timers/client";
import {
  timerScope,
  type BehaviorTimerData,
} from "../../../util/src/behavior-timers/protocol";

const EMPTY: BehaviorTimerData = Object.freeze({});
export function useBehaviorTimers(
  data: { currentMeet?: unknown; behaviorTimerScope?: string },
  enabled: boolean,
): BehaviorTimerData {
  const scope = timerScope(data);
  const [snapshot, setSnapshot] = useState(() => ({
    scope,
    value: enabled ? behaviorTimerClient.data(scope, true) : EMPTY,
  }));
  useEffect(() => {
    const update = () => {
      const value = enabled ? behaviorTimerClient.data(scope) : EMPTY;
      setSnapshot((current) =>
        current.scope === scope && current.value === value
          ? current
          : { scope, value },
      );
    };
    const unsubscribe = enabled
      ? behaviorTimerClient.subscribe(scope, update)
      : () => {};
    update();
    return unsubscribe;
  }, [scope, enabled]);
  return !enabled
    ? EMPTY
    : snapshot.scope === scope
      ? snapshot.value
      : behaviorTimerClient.data(scope);
}
